// Aggregated static problem bank. The JSON files are produced by
// scripts/writeBank.mjs (data in src/data/buildBank.ts) — do not edit them by
// hand; edit the builder and re-run `npm run bank:build`.
import type { BankProblem, LeafType } from '../../types';

import KETA_X10 from './KETA_X10.json';
import KETA_D10 from './KETA_D10.json';
import KETA_X100 from './KETA_X100.json';
import KETA_D100 from './KETA_D100.json';
import KETA_DECIMAL from './KETA_DECIMAL.json';
import KETA_DEC_X10 from './KETA_DEC_X10.json';
import KETA_DEC_X100 from './KETA_DEC_X100.json';
import DEC_COMPOSE from './DEC_COMPOSE.json';
import DEC_ADD from './DEC_ADD.json';
import DEC_SUB from './DEC_SUB.json';
import DEC_ADDSUB from './DEC_ADDSUB.json';
import UNIT_LENGTH from './UNIT_LENGTH.json';
import UNIT_DECIMAL from './UNIT_DECIMAL.json';
import UNIT_VOLUME from './UNIT_VOLUME.json';
import UNIT_WEIGHT from './UNIT_WEIGHT.json';
import UNIT_ADD from './UNIT_ADD.json';
import ROUND_NORMAL from './ROUND_NORMAL.json';
import ROUND_RANGE from './ROUND_RANGE.json';
import ROUND_WORD from './ROUND_WORD.json';
import FRAC_REDUCE from './FRAC_REDUCE.json';
import FRAC_COMMON from './FRAC_COMMON.json';
import UEKI_A from './UEKI_A.json';
import UEKI_B from './UEKI_B.json';
import UEKI_C from './UEKI_C.json';
import TAPE_LEN from './TAPE_LEN.json';
import TAPE_GLUE from './TAPE_GLUE.json';
import TAPE_NUM from './TAPE_NUM.json';
import WASA_FIND_BIG from './WASA_FIND_BIG.json';
import WASA_FIND_SMALL from './WASA_FIND_SMALL.json';
import BUNPAI_BASIC from './BUNPAI_BASIC.json';
import BUNPAI_OFFSET from './BUNPAI_OFFSET.json';

// JSON is imported with a loose inferred type, so each is coerced to
// BankProblem[]. `satisfies` then enforces that EVERY leaf type is present
// (forgetting one after adding a new type is a compile error).
export const BANK = {
  KETA_X10: KETA_X10 as BankProblem[],
  KETA_D10: KETA_D10 as BankProblem[],
  KETA_X100: KETA_X100 as BankProblem[],
  KETA_D100: KETA_D100 as BankProblem[],
  KETA_DECIMAL: KETA_DECIMAL as BankProblem[],
  KETA_DEC_X10: KETA_DEC_X10 as BankProblem[],
  KETA_DEC_X100: KETA_DEC_X100 as BankProblem[],
  DEC_COMPOSE: DEC_COMPOSE as BankProblem[],
  DEC_ADD: DEC_ADD as BankProblem[],
  DEC_SUB: DEC_SUB as BankProblem[],
  DEC_ADDSUB: DEC_ADDSUB as BankProblem[],
  UNIT_LENGTH: UNIT_LENGTH as BankProblem[],
  UNIT_DECIMAL: UNIT_DECIMAL as BankProblem[],
  UNIT_VOLUME: UNIT_VOLUME as BankProblem[],
  UNIT_WEIGHT: UNIT_WEIGHT as BankProblem[],
  UNIT_ADD: UNIT_ADD as BankProblem[],
  ROUND_NORMAL: ROUND_NORMAL as BankProblem[],
  ROUND_RANGE: ROUND_RANGE as BankProblem[],
  ROUND_WORD: ROUND_WORD as BankProblem[],
  FRAC_REDUCE: FRAC_REDUCE as BankProblem[],
  FRAC_COMMON: FRAC_COMMON as BankProblem[],
  UEKI_A: UEKI_A as BankProblem[],
  UEKI_B: UEKI_B as BankProblem[],
  UEKI_C: UEKI_C as BankProblem[],
  TAPE_LEN: TAPE_LEN as BankProblem[],
  TAPE_GLUE: TAPE_GLUE as BankProblem[],
  TAPE_NUM: TAPE_NUM as BankProblem[],
  WASA_FIND_BIG: WASA_FIND_BIG as BankProblem[],
  WASA_FIND_SMALL: WASA_FIND_SMALL as BankProblem[],
  BUNPAI_BASIC: BUNPAI_BASIC as BankProblem[],
  BUNPAI_OFFSET: BUNPAI_OFFSET as BankProblem[],
} satisfies Record<LeafType, BankProblem[]>;
